import React, { useEffect } from "react";
import Html from "utils/Html";
import { Dropdown } from "semantic-ui-react";
import { useAlluser } from "context/AlluserContext";

export default function FilterJobClass({ data }) {
  const { filters, storeFilters } = useAlluser();
  const filterName = "jobclass";
  const filterTitle = "Job Class";
  let handleEvents = {
    SelectNone: {
      OnClick: function (evt) {
        let selectedArr = [];
        // console.log("Btn Select None => " + filterName);
        storeFilters({ ...filters, jobclass: selectedArr });
      },
    },
    SelectAll: {
      OnClick: function (evt) {
        let selectedArr = [];
        for (const i in data) {
          selectedArr.push(data[i].class_id);
        }
        // console.log("Btn Select All => " + filterName, selectedArr);
        storeFilters({ ...filters, jobclass: selectedArr });
      },
    },
    OnChange: function (evt, { name, value }) {
      // console.log(name, value);
      storeFilters({ ...filters, jobclass: value });
    },
  };

  useEffect(() => {}, []);

  return (
    <div
      key={"filter-" + filterName + "-" + filters.key_form}
      className="filter-input-field select"
    >
      <Html.SelectAll handleEvents={handleEvents} />
      <label htmlFor={"filter-inp-" + filterName} className="label">
        {filterTitle}
      </label>
      <Dropdown
        fluid
        selection
        search={true}
        multiple={true}
        id={"filter-inp-" + filterName}
        name={filterName}
        placeholder={filterTitle}
        options={Html.OptionList(data, {
          id: "",
          key: filterName,
          name: "class_name",
          value: "class_id",
          optionGroup: false,
          optionNull: false,
        })}
        value={filters?.jobclass ?? []}
        onChange={handleEvents.OnChange}
        disabled={false}
        className="alluser-dropdown"
      />
      <span
        className="select-helper-text hide"
        id={"helper-text-" + filterName}
      >
        {"Please select " + filterName}
      </span>
    </div>
  );
}
